import React, { useCallback } from "react";
import { useRiderFilter } from "@/features/rider/riderStatus/hooks/useRiderFilter";
import { useRiderData } from "@/features/rider/riderStatus/hooks/useRiderData";
import { useRiderExcel } from "@/features/rider/riderStatus/hooks/useRiderExcel";

export const useRiderStatus = () => {
    const { filters, setFilters, handleFilterChange, persistFilters } = useRiderFilter();

    const {
        riders,
        loading,
        currentPage,
        totalPages,
        suppliers,
        suppliersLoading,
        contractStatusCounts,
        userType,
        handlePageChange,
        handleRiderClick,
        searchRiders: fetchAndSearch,
        getContractBadge,
        getPrepaymentBadge,
    } = useRiderData(filters, setFilters);

    const { excelDownloading, handleExcelDownload } = useRiderExcel(filters);

    const searchRiders = useCallback(async (): Promise<void> => {
        await fetchAndSearch();
        persistFilters(filters);
    }, [fetchAndSearch, persistFilters, filters]);

    const handleKeyDown = useCallback(
        (e: React.KeyboardEvent): void => {
            if (e.key === 'Enter') searchRiders();
        },
        [searchRiders],
    );

    return {
        riders,
        totalCount: contractStatusCounts.total,
        contractStatusCounts,
        loading,
        excelDownloading,
        currentPage,
        totalPages,
        suppliers,
        suppliersLoading,
        filters,
        userType,
        handlePageChange,
        handleRiderClick,
        handleFilterChange,
        handleKeyDown,
        searchRiders,
        handleExcelDownload,
        getContractBadge,
        getPrepaymentBadge,
    };
};
